module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='asset-content-wrapper'>\n  <div class='asset-image'>");
      if (this.asset.hasThumbnail()) {
        $o.push("    <img src='" + ($e($c(this.asset.get("thumb")))) + "' rel='" + ($e($c(this.asset.get("url")))) + "'>");
      } else {
        $o.push("    <div class='avatar-wrapper'>\n      <div class='avatar fa " + (this.asset.get("iconName")) + "'></div>\n    </div>");
      }
      $o.push("  </div>\n  <div class='asset-information-tint'></div>\n  <div class='asset-information'>");
      if (this.asset.isMediaLibraryAsset) {
        $o.push("    <div class='asset-options auto-width dropdown-align-right dropdown-container'>\n      <div class='asset-dropdown-icon button dropdown-ellipsis-toggle small'></div>\n      <ul class='dropdown-selection'>\n        <li>\n          <a class='blank' href='/media/" + ($e($c(this.asset.get("asset_id")))) + "' target='_blank'>Details</a>\n        </li>\n      </ul>\n    </div>");
      }
      $o.push("    <div class='asset-filename ellipsis-text' notranslate>");
      $o.push("      " + $e($c(this.asset.get("title"))));
      $o.push("    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/picker_asset_view.js.hamlc
// module id = 1359
// module chunks = 17